export function escapeMarkdown(text) {
  // Escape all markdown tokens (`_` and `*` for italic or bold if doubled, `~` for strike)
  // by appending `\\` before each of these tokens.
  // See https://github.com/bpmn-io/snarkdown/pull/5/files
  // Note: this is already done by default and will only be needed if you
  // pass `escapeParameters: false` and need to manually escape
  // because you have a translation variable that contains a mix of
  // user-input (that you want to escape) and markdown (that you want to interpret).
  return text.replace(/([_*~])/gim, '\\$1');
}